import React, { lazy, Suspense, useState, useEffect, useRef } from "react";
import { Flex, Image, Box, Grid, GridItem, Icon, Text } from "@chakra-ui/react";
import { FaCheckCircle } from "react-icons/fa";
import { useInView } from "framer-motion";

const Section2 = () => {
  const ref = useRef(null);
  const isInView = useInView(ref);
  const [currentColor, setCurrentColor] = useState("white");
  const colors = ["#ff00ff", "#6b32e3", "#20cc55", "#22e9a0"]; // Colors to sample through
  const transitionDuration = 2000;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentColor((prevColor) => {
        const currentIndex = colors.indexOf(prevColor);
        const nextIndex = (currentIndex + 1) % colors.length;
        const nextColor = colors[nextIndex];

        if (nextColor === colors[colors.length - 1]) {
          clearInterval(interval); // Stop the interval once the final color is reached
        }

        return nextColor;
      });
    }, transitionDuration);

    return () => {
      clearInterval(interval);
    };
  }, []);
  return (
    <>
      <Flex
        mt="100px"
        w="100%"
        alignItems="center"
        justifyContent="center"
        ref={ref}
      >
        <Flex
          p={{ base: "30px", md: "100px" }}
          alignItems={{
            base: "space-between",
            md: "center",
            lg: "space-between",
          }}
          justifyContent={{
            base: "space-between",
            md: "center",
            lg: "space-between",
          }}
          flexDir={{ base: "column", md: "column", lg: "row" }}
        >
          <Suspense fallback={<div>Loading...</div>}>
            <Image
              mb={{ base: "40px", md: "0px" }}
              style={{
                transform: isInView ? "none" : "translateY(200px)",
                opacity: isInView ? 1 : 0,
                transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
              }}
              mt={{ base: "20px", md: "0px" }}
              w={{ base: "100%", md: "50%" }}
              border="6px solid #131014"
              boxSize={{ base: "100%", md: "100%", lg: "50%" }}
              src={"https://i.imgur.com/coWu95K.gif"}
              borderRadius="20px"
            />
          </Suspense>

          <Flex
            w="100%"
            flexDir="column"
            alignItems="flex-start"
            justifyContent="flex-start"
            ml={{ base: "0px", md: "60px" }}
            mt={{ base: "0px", md: "20px", lg: "0px" }}
          >
            <Box
              style={{
                transform: isInView ? "none" : "translateY(-200px)",
                opacity: isInView ? 1 : 0,
                transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
              }}
              w={{ base: "100%", md: "100%", lg: "50%" }}
              fontSize={{ base: "30px", md: "40px" }}
            >
              We track EVERY token in your wallet.
            </Box>

            <Box color="gray.500" w={{ base: "100%", md: "90%" }} mt="20px">
              View all your major tokens and their Profit and Loss values at a
              glance, or switch to shitcoin viewer to see low liquidity coins
              and your holding values.
            </Box>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};

export default Section2;
